module.exports = __webpack_public_path__ + "static/media/gb.4df1e7ea.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gb.svg
// module id = 1236
// module chunks = 0